import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ChangerequestService } from 'src/app/_services/changerequest/changerequest.service';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';

@Component({
  selector: 'app-add-change-request',
  templateUrl: './add-change-request.component.html',
  styleUrls: ['./add-change-request.component.scss']
})
export class AddChangeRequestComponent implements OnInit {
  changeRequestForm
  rowData: any;
  public columnDefs: ColDef[]; 
  modeAction:number = 1 //1 - create // 2 - update
  // gridApi and columnApi  
  private api: GridApi;  
  private columnApi: ColumnApi;  
   defaultColDef:any;
   rowSelection:any
  tenantId: string;
  currentId: any;
  currentUser: any;
  selectedFile: File;
  form: FormGroup;
  sampleGridFrameworkComponents: any;
  gridLength = 0;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  
  
  constructor(
    private changereqyesrService: ChangerequestService,
    private storageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private allocationService: AllocationService,
    private route: ActivatedRoute
  ) { 
    this.changeRequestForm = new FormGroup({
      id : new FormControl(''), 
      title :   new FormControl('', [Validators.required]), 
      status :   new FormControl(''), 
      changeRequestNumber :  new FormControl(''), 
      causedBy :   new FormControl('',[Validators.required]), 
      partClassification :   new FormControl(''), 
      crResponsibility :   new FormControl(''), 
      schedule :   new FormControl(''), 
      problem :   new FormControl(''), 
      solution :   new FormControl(''), 
      impactDirectMaterialCost :   new FormControl(''), 
      impactRndOneOffCost :   new FormControl(''), 
      impactDirectLaborCost :   new FormControl(''), 
      impactPlantInvestment :   new FormControl(''), 
      impactOthers :   new FormControl(''), 
      impactTransferPrice :   new FormControl(''), 
      impactSumTranferPrice :   new FormControl(''), 
      impactCostBaringUseCase :   new FormControl(''), 
      impactWeight :   new FormControl(''), 
      impactOtherTarget :   new FormControl(''), 
      requiredChangesForCn :   new FormControl(''), 
      requiredChangesForEceRhd :   new FormControl(''), 
      requiredChangesForEceLhd :   new FormControl(''), 
      requiredChangesForFeatureList :   new FormControl(''), 
      requiredChangesForCbom :   new FormControl(''), 
      requiredChangesForEarlyBom :   new FormControl(''), 
      requiredChangesForHomologationRelevant :   new FormControl(''), 
      requiredChangesForAffectedFeature :  new FormControl(''),
    })
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get("tenantId");
    this.currentId = this.route.snapshot.queryParamMap.get('id');
    
    if (this.currentId) this.getCRById(this.currentId)
  }

  getCRById(id) {
    this.changereqyesrService.getChangeRequests(id).subscribe(response => {
      console.log(response)
      if (response) {
        this.changeRequestForm.patchValue(response)
      }
    }, error => {
      console.log('ERROR: cannot get project by id: ' + error);
    })
  }

  get f(){
    return this.changeRequestForm.controls;
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    console.log('qqqq', this.api)
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  } 


  backToChangeRequest(){
    this.router.navigate([this.tenantId + '/dashboard/project/changerequest']);
  }

  createCR() {
    let details = JSON.stringify(this.changeRequestForm.value);
    this.changereqyesrService.createChangeRequests(details).subscribe(response => {
      console.log("response: ", response);
      this.backToChangeRequest()
      // // update grid after creating new lead & close the modal
      // this.api.applyTransaction({ add: [response] });
      // $('#closeCreateModal').trigger("click");
    });
  }

  updateCR() {
      if (this.currentId) {
        this.changereqyesrService.updateChangeRequests(this.changeRequestForm.value, this.currentId).subscribe(response => {
          console.log('response', response)
          this.backToChangeRequest()
        }, error => {
          console.log('ERROR: cannot update project: ' + error);
        })
      }
    }

  performGridActionItem(params) {
    if (params.event.currentTarget.value == 'delete') {
      this.deleteGridRow(params);
    }     
  }

  private deleteGridRow(params: any) {
    this.changereqyesrService.deleteChangeRequests(params.params.data.id).subscribe(() => {
      var selectedData = params.params.data;
      this.api.applyTransaction({ remove: [selectedData] });
    });
  }

}
